import mat from '../img/materias/logo.png'

export const materiasList = ['LauraZamora']

export const users = {
    LauraZamora: {
        path: 'LauraZamora',
        component: 'General',
        job: 'Administrador',
        profile: null,
        name: "Laura",
        lastName: "Zamora",
        company: "Materias Primas",
        whats: '55 3031 4441',
        workphone: '55 3031 4441',
        email: 'lzamora@matprim.mx',
        emailAlt: null,
        facebook: null,
        instagram: null,
        tiktok: null,
        linkedin: 'https://www.linkedin.com/company/materias-primas-y-productos-terminados/',
        web: 'https://matprim.mx',
        slogan: 'Somos empresa líder en distribución de polímeros de alto desempeño en México, ofreciendo soluciones innovadoras en la industria del plástico.',
        logo: mat,
        loading: mat,
        color: '#00418b',
        textColor: '#000',
        gallery: null,
        backgroundColor: '#00418b',
        cardBackgroundColor: '#dddddd',
        btnColor: '#fff',
    }
}